export default "__VITE_PUBLIC_ASSET__475a6a6f__"